import React, { Component } from "react";
import { Modal, Row, Col } from "react-bootstrap";
import gql from "graphql-tag";
import moment from "moment";
import { withRouter } from "react-router-dom";
import { withApollo } from "react-apollo";
import { FeeReportShimmer } from "../FeeShimmer";

const GET_STUDENT_FEE_REPORT = gql`
    query getStudentFeeReport($student_id: Int, $academic_year_id: Int) {
        getStudentFeeReport(student_id: $student_id, academic_year_id: $academic_year_id) {
            fee_type_id
            fee_type_name
            total_fee
            discount
            fee_amount
            terms {
                term_no
                term_amount
                term_discount
                term_date
                is_paid
                paid_amount
                paid_date
                payment_mode_id
                payment_id
                comments
                is_due_entry
                due_from_term_no
            }
        }
    }
`;


const fmtDate  = (unix) => unix ? moment.unix(unix).format("DD/MM/YYYY") : "—";
const rupeeFmt = (v)    => `₹${(v || 0).toLocaleString("en-IN")}`;

class FeeReportDateWise extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataClear: 0,
            feeReport: [],
            loading:   false,
            activeTab: "pending",   // "pending" | "payments"
        };
    }

    componentDidUpdate() {
        if (this.props.show && this.state.dataClear === 0) {
            this.setState({ dataClear: 1, feeReport: [], activeTab: "pending" }, () => this.fetchReport());
        }
        if (!this.props.show && this.state.dataClear === 1) {
            this.setState({ dataClear: 0 });
        }
    }

    fetchReport = async () => {
        const { stateData } = this.props;
        const studentId    = stateData?.student_id;
        const academicYear = stateData?.yearSearch;
        if (!studentId || !academicYear) { this.setState({ feeReport: [], loading: false }); return; }
        this.setState({ loading: true });
        try {
            const { data } = await this.props.client.query({
                query: GET_STUDENT_FEE_REPORT,
                variables: { student_id: parseInt(studentId), academic_year_id: parseInt(academicYear) },
                fetchPolicy: "network-only",
            });
            this.setState({ feeReport: data?.getStudentFeeReport || [], loading: false });
        } catch {
            this.setState({ feeReport: [], loading: false });
        }
    };

    viewPDF = (payment) => {
        const { studentName, class_name, roll_no, admission_no, getOrganisationProfile, stateData } = this.props;
        const branchData   = (getOrganisationProfile?.branch_wise_data || []).find(a => a.branch_id == stateData?.row_branch_id);
        const orgName      = getOrganisationProfile?.organisation_name || "";
        const logoFile     = getOrganisationProfile?.logo || "";
        const address      = branchData?.branch_wise_address || "";
        const logoDataUrl  = logoFile ? `https://support.rizee.in/files/${logoFile}` : "";
        const academicYear = stateData?.academic_year_text || stateData?.academic_year_name || stateData?.year_name || "";
        const classAdm     = [class_name, admission_no].filter(Boolean).join(" / Adm No: ");
        const receiptDate  = payment.paid_date ? moment.unix(parseInt(payment.paid_date)).format("DD/MMM/YYYY") : "—";
        const totalPaid    = (payment.amount || 0).toLocaleString("en-IN");

        const dataRows = [
            academicYear ? ["Academic Year", academicYear] : null,
            ["Student Name",  studentName || "—"],
            stateData?.parent_name ? ["Parent Name", stateData.parent_name] : null,
            ["Class / Adm No", classAdm || "—"],
            ["Fee Type",      `${payment.fee_type} – Term ${payment.term_no}`],
            ["Total Paid",    `&#x20B9;${totalPaid} (${payment.payment_mode})`],
        ].filter(Boolean);

        const rowsHtml = dataRows.map(([label, value]) => `
            <tr>
                <td style="padding:6px 0;font-size:13px;color:#555;width:220px">${label}</td>
                <td style="padding:6px 0;font-size:13px;color:#555;width:20px;text-align:center">:</td>
                <td style="padding:6px 0;font-size:13px;font-weight:700;color:#111">${value}</td>
            </tr>`).join("");

        const win = window.open("", "_blank", "width=800,height=700");
        win.document.write(`<html><head><title>Fee Receipt</title><style>
            *{margin:0;padding:0;box-sizing:border-box}
            body{font-family:Arial,sans-serif;padding:24px;color:#111;font-size:12px}
            .receipt-wrapper{width:700px;margin:0 auto;border:1.5px solid #333}
            .receipt-header{display:flex;align-items:center;gap:14px;padding:14px 18px 10px;border-bottom:1.5px solid #333}
            .hdr-logo{height:56px;width:auto;object-fit:contain;flex-shrink:0}
            .hdr-info{flex:1;text-align:center}
            .org-name{font-size:18px;font-weight:700;color:#111;margin-bottom:2px}
            .org-addr{font-size:11px;color:#555;line-height:1.5;margin:0 auto;max-width:500px}
            .receipt-title{display:flex;align-items:center;padding:10px 18px;border-bottom:1.5px solid #333}
            .rt-side{flex:1;font-size:11px;font-weight:400;color:#333;line-height:1.5}
            .rt-main{font-size:16px;font-weight:700;text-align:center}
            .receipt-body{padding:14px 18px}
            .receipt-footer{border-top:1.5px solid #333;padding:10px 18px}
            @media print{html,body{height:auto!important}body{padding:2px}@page{size:auto;margin:3mm}}
        </style></head><body>
            <div class="receipt-wrapper">
                <div class="receipt-header">
                    ${logoDataUrl ? `<img class="hdr-logo" src="${logoDataUrl}" />` : ""}
                    <div class="hdr-info">
                        <div class="org-name">${orgName}</div>
                        <div class="org-addr">${address}</div>
                    </div>
                </div>
                <div class="receipt-title">
                    <div class="rt-side" style="text-align:left">Receipt No: <strong>${payment.receipt_no || "—"}</strong><br/>Adm No: <strong>${admission_no || "—"}</strong></div>
                    <div class="rt-main">Fee Receipt</div>
                    <div class="rt-side" style="text-align:right">Date: <strong>${receiptDate}</strong></div>
                </div>
                <div class="receipt-body">
                    <table style="width:100%;border-collapse:collapse">
                        <tbody>${rowsHtml}</tbody>
                    </table>
                </div>
                <div class="receipt-footer">
                    <div style="text-align:center;font-size:10px;color:#555;line-height:1.3">Note: Once a payment is made, it cannot be refunded. Thank You</div>
                    <div style="text-align:right;font-size:11px;font-weight:700;color:#333;margin-top:16px">School Stamp &amp; Sign</div>
                </div>
            </div>
            <script>window.print();window.close();<\/script>
        </body></html>`);
        win.document.close();
        win.focus();
    };

    // Consolidated statement of every payment in the history (all fee types) so the
    // user can download the whole payment history in one document instead of one receipt at a time.
    downloadAllPayments = (paymentList, totalPaid) => {
        if (!paymentList || paymentList.length === 0) {
            window.alert("No payments found to download.");
            return;
        }
        const { studentName, class_name, roll_no, admission_no, getOrganisationProfile, stateData } = this.props;
        const branchData   = (getOrganisationProfile?.branch_wise_data || []).find(a => a.branch_id == stateData?.row_branch_id);
        const orgName      = getOrganisationProfile?.organisation_name || "";
        const logoFile     = getOrganisationProfile?.logo || "";
        const address      = branchData?.branch_wise_address || "";
        const logoDataUrl  = logoFile ? `https://support.rizee.in/files/${logoFile}` : "";
        const academicYear = stateData?.academic_year_text || stateData?.academic_year_name || stateData?.year_name || "";
        const classAdm     = [class_name, admission_no].filter(Boolean).join(" / Adm No: ");

        const sorted = [...paymentList].sort((a, b) => (parseInt(a.paid_date) || 0) - (parseInt(b.paid_date) || 0));

        // Fee-level totals across all fee types in the report.
        const report = this.state.feeReport || [];
        const totalFee      = report.reduce((s, ft) => s + (parseInt(ft.total_fee) || 0), 0);
        const feeDiscount   = report.reduce((s, ft) => s + (parseInt(ft.discount) || 0), 0);
        const feeAmount     = report.reduce((s, ft) => s + (parseInt(ft.fee_amount) || (parseInt(ft.total_fee) || 0) - (parseInt(ft.discount) || 0)), 0);
        const totalDiscount = sorted.reduce((s, p) => s + (parseInt(p.discount) || 0), 0);
        const overallDue    = Math.max(0, feeAmount - totalDiscount - (totalPaid || 0));

        const rowsHtml = sorted.map((p, idx) => {
            const term = p.is_due ? `Due (Term ${p.due_from || p.term_no})` : `Term ${p.term_no}`;
            const date = p.paid_date ? moment.unix(parseInt(p.paid_date)).format("DD/MMM/YYYY") : "—";
            return `<tr>
                <td style="padding:7px 10px;border:1px solid #e5e7eb;text-align:center">${idx + 1}</td>
                <td style="padding:7px 10px;border:1px solid #e5e7eb">${p.receipt_no || "—"}</td>
                <td style="padding:7px 10px;border:1px solid #e5e7eb">${p.fee_type || "—"}</td>
                <td style="padding:7px 10px;border:1px solid #e5e7eb">${term}</td>
                <td style="padding:7px 10px;border:1px solid #e5e7eb">${date}</td>
                <td style="padding:7px 10px;border:1px solid #e5e7eb">${p.payment_mode || "—"}</td>
                <td style="padding:7px 10px;border:1px solid #e5e7eb;text-align:right">${(p.discount || 0) > 0 ? '&#x20B9;' + (p.discount || 0).toLocaleString("en-IN") : '—'}</td>
                <td style="padding:7px 10px;border:1px solid #e5e7eb;text-align:right;font-weight:700">&#x20B9;${(p.amount || 0).toLocaleString("en-IN")}</td>
            </tr>`;
        }).join("");

        const infoRows = [
            academicYear ? ["Academic Year", academicYear] : null,
            ["Student Name",   studentName || "—"],
            stateData?.parent_name ? ["Parent Name", stateData.parent_name] : null,
            ["Class / Adm No", classAdm || "—"],
        ].filter(Boolean).map(([label, value]) => `
            <tr>
                <td style="padding:4px 0;font-size:12px;color:#555;width:160px">${label}</td>
                <td style="padding:4px 0;font-size:12px;color:#555;width:14px;text-align:center">:</td>
                <td style="padding:4px 0;font-size:12px;font-weight:700;color:#111">${value}</td>
            </tr>`).join("");

        const win = window.open("", "_blank", "width=900,height=750");
        win.document.write(`<html><head><title>Payment History</title><style>
            *{margin:0;padding:0;box-sizing:border-box}
            body{font-family:Arial,sans-serif;padding:24px;color:#111;font-size:12px}
            .receipt-wrapper{width:800px;margin:0 auto;border:1.5px solid #333}
            .receipt-header{display:flex;align-items:flex-start;justify-content:space-between;padding:14px 18px 10px;border-bottom:1.5px solid #333}
            .hdr-left{display:flex;align-items:flex-start;gap:14px;flex:1}
            .hdr-left img{width:auto;height:60px;object-fit:contain;flex-shrink:0}
            .org-name{font-size:18px;font-weight:700;color:#111;margin-bottom:2px}
            .org-addr{font-size:11px;color:#555;line-height:1.5}
            .receipt-title{text-align:center;font-size:16px;font-weight:700;padding:10px 0;border-bottom:1.5px solid #333}
            .receipt-body{padding:14px 18px}
            .history-table{width:100%;border-collapse:collapse;margin-top:12px;font-size:12px}
            .history-table th{padding:8px 10px;border:1px solid #333;background:#f3f4f6;font-size:12px;text-align:left}
            .totals{margin-top:14px;display:flex;flex-wrap:wrap;justify-content:flex-end;gap:12px 30px;font-size:13px}
            .receipt-footer{border-top:1.5px solid #333;padding:10px 18px}
            @media print{html,body{height:auto!important}body{padding:2px}@page{size:auto;margin:5mm}}
        </style></head><body>
            <div class="receipt-wrapper">
                <div class="receipt-header">
                    <div class="hdr-left">
                        ${logoDataUrl ? `<img src="${logoDataUrl}" />` : ""}
                        <div>
                            <div class="org-name">${orgName}</div>
                            <div class="org-addr">${address}</div>
                        </div>
                    </div>
                    <div style="text-align:right;font-size:10px;color:#333;min-width:160px;line-height:1.9">
                        <div>Date: <strong>${moment().format("DD/MMM/YYYY")}</strong></div>
                        <div>Total Receipts: <strong>${sorted.length}</strong></div>
                    </div>
                </div>
                <div class="receipt-title">Payment History</div>
                <div class="receipt-body">
                    <table style="width:100%;border-collapse:collapse"><tbody>${infoRows}</tbody></table>
                    <table class="history-table">
                        <thead>
                            <tr>
                                <th style="text-align:center;width:40px">#</th>
                                <th>Receipt No</th>
                                <th>Fee Type</th>
                                <th>Term</th>
                                <th>Paid Date</th>
                                <th>Mode</th>
                                <th style="text-align:right">Discount</th>
                                <th style="text-align:right">Amount</th>
                            </tr>
                        </thead>
                        <tbody>${rowsHtml}</tbody>
                    </table>
                    <div class="totals">
                        ${totalFee > 0 ? `<div>Total Fee: <strong style="color:#111">&#x20B9;${totalFee.toLocaleString("en-IN")}</strong></div>` : ''}
                        ${feeDiscount > 0 ? `<div>Fee Discount: <strong style="color:#1d4ed8">&#x20B9;${feeDiscount.toLocaleString("en-IN")}</strong></div>` : ''}
                        ${totalDiscount > 0 ? `<div>Term Discount: <strong style="color:#1d4ed8">&#x20B9;${totalDiscount.toLocaleString("en-IN")}</strong></div>` : ''}
                        <div>Total Paid: <strong style="color:#15803d">&#x20B9;${(totalPaid || 0).toLocaleString("en-IN")}</strong></div>
                        ${overallDue > 0 ? `<div>Balance Due: <strong style="color:#dc2626">&#x20B9;${overallDue.toLocaleString("en-IN")}</strong></div>` : ''}
                    </div>
                </div>
                <div class="receipt-footer">
                    <div style="text-align:center;font-size:10px;color:#555;margin-bottom:2px">Note: Once a payment is made, it cannot be refunded.</div>
                    <div style="text-align:center;font-size:10px;color:#555">Thank You</div>
                    <div style="text-align:right;font-size:11px;font-weight:700;color:#333;margin-top:28px">School Stamp &amp; Sign</div>
                </div>
            </div>
            <script>window.print();window.close();<\/script>
        </body></html>`);
        win.document.close();
        win.focus();
    };

    render() {
        const { studentName, class_name, roll_no, examName, getPaymentModes } = this.props;
        const { feeReport, loading, activeTab } = this.state;
        const payModes = getPaymentModes || [];

        const pendingRows = feeReport.map(ft => {
            const paid    = (ft.terms || []).reduce((s, t) => s + (parseInt(t.paid_amount) || 0), 0);
            const total   = ft.fee_amount || ft.total_fee || 0;
            const pending = Math.max(0, total - paid);
            return { name: ft.fee_type_name, total, paid, pending };
        });

        const paymentList = [];
        feeReport.forEach(ft => {
            // Include any term with a payment OR a discount (a fully-waived term has ₹0 paid but a discount).
            (ft.terms || []).filter(t => (parseInt(t.paid_amount) || 0) > 0 || (parseInt(t.term_discount) || 0) > 0).forEach(t => {
                const pm = payModes.find(p => p.id == t.payment_mode_id);
                paymentList.push({
                    fee_type:     ft.fee_type_name,
                    term_no:      t.term_no,
                    is_due:       t.is_due_entry == 1,
                    due_from:     t.due_from_term_no,
                    amount:       parseInt(t.paid_amount) || 0,
                    discount:     parseInt(t.term_discount) || 0,
                    paid_date:    t.paid_date,
                    payment_mode: pm?.payment_mode || "—",
                    receipt_no:   t.payment_id || "—",
                });
            });
        });

        const totalPaid    = pendingRows.reduce((s, r) => s + r.paid, 0);
        const totalPending = pendingRows.reduce((s, r) => s + r.pending, 0);

        const S = {
            hdr:   { background: "linear-gradient(135deg,#6366f1,#8b5cf6)", padding: "16px 22px" },
            body:  { background: "#f8fafc", padding: "0", maxHeight: "76vh", overflowY: "auto" },
            th:    { padding: "10px 14px", fontSize: 11, fontWeight: 700, color: "#6b7280", textTransform: "uppercase", letterSpacing: "0.5px", background: "#f8fafc", borderBottom: "1px solid #e5e7eb", whiteSpace: "nowrap" },
            td:    { padding: "10px 14px", fontSize: 13, borderBottom: "1px solid #f3f4f6", verticalAlign: "middle" },
            badge: (bg, clr) => ({ background: bg, color: clr, borderRadius: 20, padding: "2px 10px", fontSize: 11, fontWeight: 700, display: "inline-block", whiteSpace: "nowrap" }),
        };

        const tabs = [
            { key: "pending",  label: "Pending Amount", icon: "fal fa-clock",          count: pendingRows.filter(r => r.pending > 0).length },
            { key: "payments", label: "Payment History", icon: "fal fa-check-circle",   count: paymentList.length },
        ];

        return (
            <Modal {...this.props} size="xl" aria-labelledby="fee-report-modal">

                {/* ── Header ── */}
                <div style={S.hdr}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                        <div>
                            <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 8 }}>
                                <div style={{ width: 7, height: 7, borderRadius: "50%", background: "rgba(255,255,255,0.5)" }} />
                                <span style={{ color: "#fff", fontWeight: 700, fontSize: 16 }}>Fee Report</span>
                            </div>
                            <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                                {[studentName, roll_no && `Adm: ${roll_no}`, class_name, examName].filter(Boolean).map((chip, i) => (
                                    <span key={i} style={{ background: "rgba(255,255,255,0.18)", color: "#fff", borderRadius: 20, padding: "2px 12px", fontSize: 12, fontWeight: 600 }}>{chip}</span>
                                ))}
                            </div>
                        </div>
                        <button onClick={this.props.onHide} style={{ background: "none", border: "none", color: "rgba(255,255,255,0.8)", fontSize: 22, cursor: "pointer", lineHeight: 1, padding: 0 }}>×</button>
                    </div>

                    {/* ── Tabs ── */}
                    {!loading && (
                        <div style={{ display: "flex", gap: 6, marginTop: 14 }}>
                            {tabs.map(tab => {
                                const active = activeTab === tab.key;
                                return (
                                    <button key={tab.key} onClick={() => this.setState({ activeTab: tab.key })}
                                        style={{ display: "flex", alignItems: "center", gap: 7, border: "none", cursor: "pointer", borderRadius: "8px 8px 0 0", padding: "8px 18px", fontWeight: 700, fontSize: 13, transition: "all 0.15s",
                                            background: active ? "#fff" : "rgba(255,255,255,0.15)",
                                            color:      active ? "#6366f1" : "rgba(255,255,255,0.85)",
                                            boxShadow:  active ? "0 -2px 8px rgba(0,0,0,0.08)" : "none",
                                        }}>
                                        <i className={tab.icon} style={{ fontSize: 13 }} />
                                        {tab.label}
                                        <span style={{ background: active ? "#ede9fe" : "rgba(255,255,255,0.25)", color: active ? "#6d28d9" : "#fff", borderRadius: 20, padding: "1px 8px", fontSize: 11, fontWeight: 700, minWidth: 20, textAlign: "center" }}>
                                            {tab.count}
                                        </span>
                                    </button>
                                );
                            })}
                        </div>
                    )}
                </div>

                <Modal.Body style={S.body}>
                    {loading ? (
                        <FeeReportShimmer />
                    ) : (
                        <>
                            {/* ── Tab: Pending Amount ── */}
                            {activeTab === "pending" && (
                                <div style={{ padding: "20px 22px" }}>
                                    {/* Summary chips */}
                                    <div style={{ display: "flex", gap: 12, marginBottom: 18, flexWrap: "wrap" }}>
                                        {[
                                            { label: "Total Fee",  value: pendingRows.reduce((s, r) => s + r.total, 0), bg: "linear-gradient(135deg,#4f46e5,#7c3aed)", icon: "fal fa-rupee-sign" },
                                            { label: "Paid",       value: totalPaid,    bg: "linear-gradient(135deg,#059669,#10b981)", icon: "fal fa-check-circle" },
                                            { label: "Pending",    value: totalPending, bg: "linear-gradient(135deg,#d97706,#f59e0b)", icon: "fal fa-clock" },
                                        ].map(({ label, value, bg, icon }) => (
                                            <div key={label} style={{ flex: 1, minWidth: 140, background: bg, borderRadius: 12, padding: "12px 16px", color: "#fff", display: "flex", alignItems: "center", gap: 12, boxShadow: "0 2px 10px rgba(0,0,0,0.10)" }}>
                                                <div style={{ background: "rgba(255,255,255,0.2)", borderRadius: 8, width: 38, height: 38, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                                                    <i className={icon} style={{ fontSize: 17 }} />
                                                </div>
                                                <div>
                                                    <div style={{ fontSize: 10, opacity: 0.85, fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.4px" }}>{label}</div>
                                                    <div style={{ fontSize: 17, fontWeight: 800 }}>{rupeeFmt(value)}</div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>

                                    <div style={{ background: "#fff", borderRadius: 14, border: "1px solid #e5e7eb", overflow: "hidden", boxShadow: "0 1px 6px rgba(0,0,0,0.05)" }}>
                                        <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                            <thead>
                                                <tr>
                                                    <th style={S.th}>#</th>
                                                    <th style={S.th}>Fee Type</th>
                                                    <th style={{ ...S.th, textAlign: "right" }}>Total Fee</th>
                                                    <th style={{ ...S.th, textAlign: "right" }}>Paid</th>
                                                    <th style={{ ...S.th, textAlign: "right" }}>Pending</th>
                                                    <th style={{ ...S.th, textAlign: "center" }}>Status</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {pendingRows.map((r, i) => (
                                                    <tr key={i} style={{ background: i % 2 === 0 ? "#fff" : "#fafafa" }}>
                                                        <td style={{ ...S.td, color: "#9ca3af", width: 36 }}>{i + 1}</td>
                                                        <td style={{ ...S.td, fontWeight: 600, color: "#374151" }}>{r.name}</td>
                                                        <td style={{ ...S.td, textAlign: "right", color: "#6b7280" }}>{rupeeFmt(r.total)}</td>
                                                        <td style={{ ...S.td, textAlign: "right", fontWeight: 700, color: "#059669" }}>{rupeeFmt(r.paid)}</td>
                                                        <td style={{ ...S.td, textAlign: "right", fontWeight: 700, color: r.pending > 0 ? "#dc2626" : "#059669" }}>{rupeeFmt(r.pending)}</td>
                                                        <td style={{ ...S.td, textAlign: "center" }}>
                                                            {r.pending === 0
                                                                ? <span style={S.badge("#dcfce7", "#15803d")}>Cleared</span>
                                                                : r.paid === 0
                                                                ? <span style={S.badge("#fef2f2", "#dc2626")}>Unpaid</span>
                                                                : <span style={S.badge("#fef3c7", "#b45309")}>Partial</span>}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                            <tfoot>
                                                <tr style={{ background: "#f8fafc", borderTop: "2px solid #e5e7eb" }}>
                                                    <td colSpan={2} style={{ ...S.td, fontWeight: 700, color: "#374151" }}>Total</td>
                                                    <td style={{ ...S.td, textAlign: "right", fontWeight: 700, color: "#374151" }}>{rupeeFmt(pendingRows.reduce((s, r) => s + r.total, 0))}</td>
                                                    <td style={{ ...S.td, textAlign: "right", fontWeight: 800, color: "#059669" }}>{rupeeFmt(totalPaid)}</td>
                                                    <td style={{ ...S.td, textAlign: "right", fontWeight: 800, color: "#dc2626" }}>{rupeeFmt(totalPending)}</td>
                                                    <td />
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>
                                </div>
                            )}

                            {/* ── Tab: Payment History ── */}
                            {activeTab === "payments" && (
                                <div style={{ padding: "20px 22px" }}>
                                    {paymentList.length === 0 ? (
                                        <div style={{ textAlign: "center", padding: "60px 0", color: "#9ca3af" }}>
                                            <i className="fal fa-inbox" style={{ fontSize: 32, display: "block", marginBottom: 10 }} />
                                            No payments recorded yet.
                                        </div>
                                    ) : (
                                        <>
                                        <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 12 }}>
                                            <button
                                                onClick={() => this.downloadAllPayments(paymentList, totalPaid)}
                                                title="Download all payment history"
                                                style={{ background: "#eff6ff", border: "1px solid #bfdbfe", borderRadius: 8, padding: "8px 16px", fontSize: 12, fontWeight: 700, color: "#1d4ed8", cursor: "pointer", display: "inline-flex", alignItems: "center", gap: 7 }}
                                            >
                                                <i className="fas fa-download" /> Download All History
                                            </button>
                                        </div>
                                        <div style={{ background: "#fff", borderRadius: 14, border: "1px solid #e5e7eb", overflow: "hidden", boxShadow: "0 1px 6px rgba(0,0,0,0.05)" }}>
                                            <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                                <thead>
                                                    <tr>
                                                        <th style={S.th}>#</th>
                                                        <th style={S.th}>Fee Type</th>
                                                        <th style={S.th}>Term</th>
                                                        <th style={{ ...S.th, textAlign: "right" }}>Amount</th>
                                                        <th style={S.th}>Paid Date</th>
                                                        <th style={S.th}>Mode</th>
                                                        <th style={S.th}>Receipt No</th>
                                                        <th style={{ ...S.th, textAlign: "center" }}>View</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {paymentList.map((p, i) => (
                                                        <tr key={i} style={{ background: i % 2 === 0 ? "#fff" : "#fafafa" }}>
                                                            <td style={{ ...S.td, color: "#9ca3af", width: 36 }}>{i + 1}</td>
                                                            <td style={{ ...S.td, fontWeight: 600, color: "#374151" }}>{p.fee_type}</td>
                                                            <td style={{ ...S.td, color: "#6b7280" }}>
                                                {p.is_due ? `Due (Term ${p.due_from || p.term_no})` : `Term ${p.term_no}`}
                                            </td>
                                                            <td style={{ ...S.td, textAlign: "right", fontWeight: 700, color: "#059669" }}>{rupeeFmt(p.amount)}</td>
                                                            <td style={{ ...S.td, color: "#6b7280", whiteSpace: "nowrap" }}>{fmtDate(p.paid_date)}</td>
                                                            <td style={S.td}>
                                                                <span style={S.badge("#ede9fe", "#6d28d9")}>{p.payment_mode}</span>
                                                            </td>
                                                            <td style={S.td}>
                                                                <span style={S.badge("#f0f9ff", "#0369a1")}>{p.receipt_no}</span>
                                                            </td>
                                                            <td style={{ ...S.td, textAlign: "center" }}>
                                                                <button onClick={() => this.viewPDF(p)}
                                                                    style={{ background: "#eff6ff", border: "1px solid #bfdbfe", borderRadius: 8, padding: "5px 12px", fontSize: 12, fontWeight: 600, color: "#1d4ed8", cursor: "pointer", display: "inline-flex", alignItems: "center", gap: 5 }}>
                                                                    <i className="fas fa-eye" style={{ fontSize: 11 }} /> View Receipt
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                                <tfoot>
                                                    <tr style={{ background: "#f8fafc", borderTop: "2px solid #e5e7eb" }}>
                                                        <td colSpan={3} style={{ ...S.td, fontWeight: 700, color: "#374151" }}>Total Paid</td>
                                                        <td style={{ ...S.td, textAlign: "right", fontWeight: 800, color: "#059669" }}>{rupeeFmt(totalPaid)}</td>
                                                        <td colSpan={4} />
                                                    </tr>
                                                </tfoot>
                                            </table>
                                        </div>
                                        </>
                                    )}
                                </div>
                            )}
                        </>
                    )}
                </Modal.Body>
            </Modal>
        );
    }
}

export default withRouter(withApollo(FeeReportDateWise));
